"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeAssign = safeAssign;
const class_transformer_1 = require("class-transformer");
function safeAssign(target, source) {
    Object.assign(target, (0, class_transformer_1.plainToInstance)(Object.getPrototypeOf(target).constructor, source, {
        // Exclude properties not decorated with @Expose()
        excludeExtraneousValues: true,
        strategy: "exposeAll",
    }));
    return target;
}
//# sourceMappingURL=safe-assign.js.map